












import Proxyable from '@/mixins/proxyable';
import { Agent } from '@/models/agent';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

export default Proxyable.extend({
  name: 'AgentPicker',

  computed: {
    agents: get<Agent[]>('agent/agents')
  },

  mounted() {
    this.init();
  },

  methods: {
    ...mapActions({
      fetchAgents: 'agent/fetchAgents'
    }),

    init() {
      if (!this.agents.length) {
        this.fetchAgents();
      }
    }
  }
});
